export const TestIds = {
  overlay: 'bannerOverlay',
  logo: 'bannerLogo',
  content: 'bannerContent',
} as const;
